var React = require('react');

function PinchedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M545.464 0C503.043 53.4475 439.947 87.3438 369.673 87.3438C299.292 87.3438 236.303 53.4475 193.881 0H0V500H192.489C235.017 445.511 298.542 410.921 369.673 410.921C440.804 410.921 504.329 445.511 546.857 500H738V0H545.464Z"}));
}

PinchedInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = PinchedInline;

PinchedInline.default = PinchedInline;
